import { render, staticRenderFns } from "./CurrentStatus.vue?vue&type=template&id=016d2c64&"
import script from "./CurrentStatus.vue?vue&type=script&lang=js&"
export * from "./CurrentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports